module.exports = __webpack_public_path__ + "static/house-052302a94fa7b032dd35332c6b613598.svg";